import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { LG, MD } from '@zendeskgarden/react-typography';
import { Dot, StyledChooseOurCompany, Reason } from './ChooseOurCompany.styles.js';
import {  
  ShieldCheckLight
  } from 'svg/svgIcons';


const ChooseOurCompany = (props) => {
  return (
    <StyledChooseOurCompany>
      <div style={{maxWidth: '650px', margin: '80px auto 0'}}>
        <Row>
          <Col className="shield" size="auto">
            <div style={{height: '60px'}}>
              <ShieldCheckLight width="80px" height="70px" />
            </div>
          </Col>
          <Col>
            <div>
              <MD scaled uppercase blue tag="h3" semibold>The Most Trusted Name In Medical Imaging</MD>
              <LG style={{maxWidth: '590px'}} paddingTopSm paddingBottomSm navy light tag="h3">Ensuring Artifact Free MRI Imaging through consultation to installation.</LG>
            </div>
          </Col>
        </Row>

          <Row>
            <Col className="shield" size="auto">
              <div style={{width: '80px'}}/>
            </Col>
            <Col>

              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">Our company’s focus is to do things right, the first time. </LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">We keep things simple, we do good business.</LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">Our core values are: Brutal Honesty, Open Communication, Dependability and Exemplary Execution Integrity. </LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">When a site is down or image quality is off, when no one can figure out why….We’re the team the professionals call.</LG></Reason>

              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">MRT is the Industry’s Top Provider of MRI and CT room construction, shielding, project management, equipment procurement and service.</LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">MRT only works with the best, most qualified professionals in the industry so that our clients can trust their project is in competent hand</LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">Every job is an opportunity to prove the legitimacy of our reputation. </LG></Reason>
            </Col>
          </Row>
      </div>

      
    </StyledChooseOurCompany>

  )
};

export default ChooseOurCompany;

